import { InstructionsStepCtrl } from './instructions.controller';

export const InstructionsStepComponent = {
  controller: InstructionsStepCtrl,
  bindings: {
    nextStep: '&',
    selectedGradDate: '<',
  },
  template: require('./instructions.html'),
};
